import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-checkbox-big-with-label',
  templateUrl: './checkbox-big-with-label.component.html',
  styleUrls: ['./checkbox-big-with-label.component.scss']
})
export class CheckboxBigWithLabelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
